import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass({
            'table__header-row': true,
          })
}

import { computed, StyleValue } from 'vue';
import { i18n } from '@/i18n';
import { LoadingStatus, loadingStatusHelpers } from './types';
import EzTableLoadingState from './EzTableLoadingState.vue';
import EzTableErrorState from './EzTableErrorState.vue';
import EzTableZeroMatchState from './EzTableZeroMatchState.vue';

type Props = {
  gridTemplateColumns: string[];
  stickyHeader?: boolean;
  stickyLeftColumns?: boolean;
  stickyColumnIndexes?: number[];
  maxHeight?: string;
  loadingStatus?: LoadingStatus;
  isVerticalScrollable?: boolean;
};

/**
 * イベント定義
 */
interface Emits {
  /** スクロールイベント */
  scroll: [e: Event];
  /** エラー状態での再試行ボタンクリック時 */
  retry: [];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EzTable',
  props: {
    gridTemplateColumns: {},
    stickyHeader: { type: Boolean, default: false },
    stickyLeftColumns: { type: Boolean, default: false },
    stickyColumnIndexes: { default: () => [] },
    maxHeight: { default: 'auto' },
    loadingStatus: { default: () => ({ type: 'success' }) },
    isVerticalScrollable: { type: Boolean, default: true }
  },
  emits: ["scroll", "retry"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "aebcc27c": (gridTemplateColumnsStyle.value)
}))

const t = i18n.t;

/**
 * EzTableコンポーネントのプロパティ
 * @property {string[]} gridTemplateColumns - グリッドの各列の幅を定義する配列
 * @property {boolean} stickyHeader - ヘッダーを固定するかどうか
 * @property {boolean} stickyLeftColumns - 左側の列を固定するかどうか
 * @property {number[]} stickyColumnIndexes - 左側に固定する列のインデックス配列
 * @property {string} maxHeight - テーブルの最大高さ (例: '500px', '80vh')
 * @property {LoadingStatus} loadingStatus - テーブルのローディング状態
 */
const props = __props;

const emits = __emit;

const gridTemplateColumnsStyle = computed(() => props.gridTemplateColumns.join(' '));

/**
 * テーブルのスタイルを計算する
 */
const tableStyle = computed((): StyleValue => {
  return {
    maxHeight: props.maxHeight !== 'auto' ? props.maxHeight : undefined,
    overflowY: props.isVerticalScrollable ? 'auto' : 'hidden',
  };
});

/**
 * 現在のローディング状態の判定を行う
 */
const currentLoadingStatus = computed(() => props.loadingStatus);

/**
 * 通常のテーブルコンテンツを表示するかどうか
 */
const shouldShowTable = computed(() => {
  return loadingStatusHelpers.shouldShowContent(currentLoadingStatus.value);
});

/**
 * エラー状態での再試行ハンドラ
 */
const handleRetry = () => {
  emits('retry');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ez-table",
    style: _normalizeStyle(tableStyle.value),
    onScroll: _cache[0] || (_cache[0] = 
      (e) => {
        emits('scroll', e);
      }
    )
  }, [
    (shouldShowTable.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: _normalizeClass(["table__header-container", { 'table__header-row--sticky': props.stickyHeader }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "header")
            ])
          ], 2),
          _renderSlot(_ctx.$slots, "body")
        ], 64))
      : (_unref(loadingStatusHelpers).isLoading(currentLoadingStatus.value))
        ? _renderSlot(_ctx.$slots, "loading", { key: 1 }, () => [
            _createVNode(EzTableLoadingState)
          ])
        : (_unref(loadingStatusHelpers).isError(currentLoadingStatus.value))
          ? _renderSlot(_ctx.$slots, "error", {
              key: 2,
              errorMessage: currentLoadingStatus.value,
              retry: handleRetry
            }, () => [
              _createVNode(EzTableErrorState, { onRetry: handleRetry })
            ])
          : (_unref(loadingStatusHelpers).isZeroMatch(currentLoadingStatus.value))
            ? _renderSlot(_ctx.$slots, "zero-match", { key: 3 }, () => [
                _createVNode(EzTableZeroMatchState)
              ])
            : _createCommentVNode("", true)
  ], 36))
}
}

})